import React from 'react'

export default function Upload(props) {
    return (
        <svg 
            width="20" 
            height="18" 
            viewBox="0 0 20 18" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path 
                d="M13.3326 12.3334L9.99923 9.00003M9.99923 9.00003L6.6659 12.3334M9.99923 9.00003V16.5M16.9909 14.325C17.8037 13.8819 18.4458 13.1808 18.8158 12.3322C19.1858 11.4837 19.2627 10.5361 19.0344 9.63894C18.8061 8.74182 18.2855 7.94629 17.5548 7.3779C16.8241 6.80951 15.925 6.50064 14.9992 6.50003H13.9492C13.697 5.5244 13.2269 4.61864 12.5742 3.85085C11.9215 3.08307 11.1033 2.47324 10.181 2.0672C9.2587 1.66116 8.25636 1.46949 7.24933 1.5066C6.2423 1.5437 5.25679 1.80861 4.36688 2.28142C3.47697 2.75422 2.70583 3.42261 2.11142 4.23635C1.51701 5.05008 1.11481 5.98797 0.935051 6.97952C0.755293 7.97107 0.802655 8.99047 1.07358 9.96108C1.3445 10.9317 1.83194 11.8282 2.49923 12.5834" 
                stroke={props.color || "#475467"} 
                strokeWidth="1.66667" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    )
}
